import React, {Component} from 'react'
import UnauthorizedText from '../components/UnauthorizedText'

import {
  ReactGoogleAnalytics,
} from '../helper/functions'

import {Title} from '../helper/consts'

import Head from '../components/Head'

const style = {
  container:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  }
}

export default class FourOhFour extends Component{

  componentDidMount(){
    ReactGoogleAnalytics('Errors','404',window.location.hash,null,null);
  }
  render(){
    return(
      <React.Fragment>
        <Head title={`404 | ${Title}`} />
        <div className="body" style={style.container}>
          <UnauthorizedText text='404' subText={`Uh Oh. Looks like you've landed on a page that doesn't exist. We've logged this error for our engineers to review.`} />
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/FourOhFour.js